export const emptyPayload = {
  payload: {
    results: {},
    extras: []
  }
}
